import classNames from 'classnames';
import React__default from 'react';
import { useToggleButtonGroupItem } from 'react-aria';
import { ToggleGroupStateContext } from 'react-aria-components';
import './ToggleCard.scss';

const ToggleCard = (props) => {
    const ref = React__default.useRef(null);
    const state = React__default.useContext(ToggleGroupStateContext);
    const { buttonProps, isPressed, isSelected } = useToggleButtonGroupItem(props, state, ref);
    return (React__default.createElement("div", { ...buttonProps, className: classNames('toggle-card--rev', props.badgeLabel && 'has-badge', props.className), "data-pressed": isPressed, "data-selected": isSelected, "data-has-open-overlay": props.hasOpenOverlay, ref: ref },
        props.badgeLabel && React__default.createElement("div", { className: 'toggle-card-badge--rev' }, props.badgeLabel),
        props.children));
};

export { ToggleCard };
//# sourceMappingURL=ToggleCard.js.map
